import { reduce } from "lodash"

export default function getURLSortState(search) {
    const params = new URLSearchParams(search)
    const ordering = params.get("ordering")

    if (!ordering) {
        return {}
    }

    return reduce(
        ordering.trim().split(","),
        (acc, crr) => {
            if (crr.startsWith("-")) {
                return { ...acc, [crr.replace("-", "")]: "desc" }
            }
            return { ...acc, [crr]: "asc" }
        },
        {}
    )
}
